export const BOOKINGS_ROUTE_PREFIX: string = '/dashboard/bookings';

interface BookingsRoutes {
  index: {
    getUrl: () => string;
    path: string;
    relativePath: string;
  };
}

const bookingsRoutes: BookingsRoutes = {
  index: {
    path: BOOKINGS_ROUTE_PREFIX,
    getUrl: (): string => BOOKINGS_ROUTE_PREFIX,
    relativePath: 'bookings'
  }
};

export default bookingsRoutes;
